import React from "react";
import {Button, Col, message, Row, Tabs} from "antd";
import LoadingIndicator from "./LoadingIndicator";
import moment from "moment";
import UploadWrapper from "./UploadWrapper";

import CustomerAcceptanceCorporateAccountUser from "./CustomerAcceptanceCorporateAccountUser";
import {submitDocumentCorporateAccount} from "../api/api";
import {displayGenericError} from "../common/notifications";

export default class CustomerAcceptanceCorporateForm extends React.Component {
    state = {
        isLoading: false
    }
    handleSubmit = () => {
        submitDocumentCorporateAccount(this.props.onboardingData.onboardingType)
            .then(() => {
                message.info(
                    "Thank you for verifying, your account review will be completed soon"
                );

                this.props.nextTab({
                    isSubmitted: true,
                });
            })
            .catch(error => {
                displayGenericError(error)
            });
    }

    render() {
        const {customerAccount, onboardingData} = this.props;
        const {isLoading} = this.state;
        if (isLoading) {
            return <LoadingIndicator/>;
        }

        return (
            <div>
                <div className="form--customer-acceptance" style={{paddingBottom: '0'}}>
                    <h2 style={{paddingLeft: '5px', whiteSpace: 'nowrap'}}>General Corporate Information</h2>
                    <div style={{marginLeft: '5px'}}>
                        <Row gutter={24}>
                            <Col className="gutter-row" span={12}>
                                <label>Name of Business</label>
                                <input value={customerAccount.corporateAccountDetails.nameOfBusiness} disabled/>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <label>Business Registration Number</label>
                                <input value={customerAccount.corporateAccountDetails.businessRegistrationNumber}
                                       disabled/>
                            </Col>
                        </Row>

                        <Row gutter={24}>
                            <Col className="gutter-row" span={12}>
                                <label>Company’s date of incorporation</label>
                                <input value={customerAccount.corporateAccountDetails.businessRegistrationDate} disabled/>
                            </Col>
                            <Col className="gutter-row" span={12}>
                                <label>Registered Address</label>
                                <input value={customerAccount.corporateAccountDetails.registeredAddress} disabled/>
                            </Col>
                        </Row>


                        <Row gutter={24}>
                            <Col className="gutter-row" span={12}>
                                {(onboardingData.onboardingType === 'timeSchedule') && (
                                    <label>
                                        Verification Method: Video Call for Identity Verification
                                    </label>)}

                                {(onboardingData.onboardingType === 'attachedDocument') && (
                                    <label>
                                        Verification Method: Corporate documents
                                    </label>)}

                            </Col>

                            <Col className="gutter-row" span={12}>
                                {(onboardingData.onboardingType === 'timeSchedule') && (
                                    <label>{onboardingData.dateSelect} {onboardingData.timeSelect}</label>
                                )}
                                {(onboardingData.onboardingType === 'attachedDocument' && onboardingData.documents) && (
                                    <div>
                                        <UploadWrapper
                                            upload={this.handleUpload}
                                            file={
                                                onboardingData.documents["CERTIFICATE_OF_INCORPORATION_BUSINESS_REGISTRATION"]
                                            }
                                            title="Certificate of Incorporation / Business Registration"
                                            type="CERTIFICATE_OF_INCORPORATION_BUSINESS_REGISTRATION"
                                            handleRemoveFile={this.handleRemoveFile}
                                            disabled={true}

                                        />

                                        <UploadWrapper
                                            upload={this.handleUpload}
                                            file={
                                                onboardingData.documents[
                                                    "MEMORANDUM_AND_ARTICLES_OF_ASSOCIATION"
                                                    ]
                                            }
                                            title="Memorandum and Articles of Association"
                                            type="MEMORANDUM_AND_ARTICLES_OF_ASSOCIATION"
                                            handleRemoveFile={this.handleRemoveFile}
                                            disabled={true}

                                        />

                                        <UploadWrapper
                                            upload={this.handleUpload}
                                            file={
                                                onboardingData.documents[
                                                    "COMPANY_SEARCH_REPORT"
                                                    ]
                                            }
                                            title="Company Search Report / Certificate of Incumbency"
                                            type="COMPANY_SEARCH_REPORT"
                                            handleRemoveFile={this.handleRemoveFile}
                                            disabled={true}

                                        />


                                        <UploadWrapper
                                            upload={this.handleUpload}
                                            file={
                                                onboardingData.documents[
                                                    "BOARD_RESOLUTION_FOR_ACCOUNT_OPENING"
                                                    ]
                                            }
                                            title="Board Resolution for Account Opening"
                                            type="BOARD_RESOLUTION_FOR_ACCOUNT_OPENING"
                                            handleRemoveFile={this.handleRemoveFile}
                                            disabled={true}

                                        />
                                    </div>
                                )}
                            </Col>

                        </Row>


                    </div>
                    <div className="form--customer-acceptance">
                        <h2 style={{paddingLeft: '5px', whiteSpace: 'nowrap'}}>Corp User</h2>
                    </div>
                </div>
                <CustomerAcceptanceCorporateAccountUser corporateAccountUsers={this.props.corporateAccountUsers}
                                                        prevTab={this.prevTab} disabled={true}
                                                        handleSubmit={this.verifiedCorpDocumentUploaded}/>

                <Row gutter={24}>
                    <Col style={{textAlign: 'center'}}>

                        <Button className="bt-skip" onClick={this.props.prevTab}>
                            Back
                        </Button>
                        <Button
                            className="bt-next"
                            type="primary"
                            onClick={this.handleSubmit}>
                            Confirm
                        </Button>


                    </Col>
                </Row>
            </div>)

    }
}